import { push, replace } from "react-router-redux";

/*
	Perform router transition through react-router-redux
	string route - destination route
*/
export function performRoute(route) {
  return function (dispatch) {
    dispatch(push(route));
  };
}

/*
	Perform router transition in a manner that is synced with the store
	and update workorders after routing
	string route - destination route
	string endpoint - arguement passed to fetchWorkorders
*/
export function performRouteAndUpdate(route, endpoint) {
  return function (dispatch) {
    dispatch(push(route));
    dispatch(fetchWorkorders(endpoint));
  };
}

/*
	Sends request to backend for user data
	object data - contains info collected from login form
	string redirect - path to redirect to on successful login
*/
export function login(data, redirect, route) {
  return function (dispatch) {
    dispatch(loggingIn);
    var json = JSON.stringify({
      ...data,
    });
    return fetch(route, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: json,
    })
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) => {
        return json;
      })
      .then((json) => handleMessage(dispatch, json))
      .then((json) => dispatch(loggedIn(json)))
      .then((json) => dispatch(fetchJobs(json.data.jwt)))
      .then(() =>
        redirect ? dispatch(replace(redirect)) : dispatch(replace("/Home")),
      )
      .catch((err) => console.log(err));
  };
}

/*
	Displays error message on login screen based on server response
	func dispatch - enables function dispatching
	object json - contains server response message
*/
function handleMessage(dispatch, json) {
  if (json.message) {
    dispatch(setLoginMessage(json.message));
  } else {
    return json;
  }
}

/*
	
*/
export function setMessage(message) {
  return function (dispatch) {
    dispatch(setLoginMessage(message));
  };
}

/*
	Dispatches functions that clear user state in frontend
	effectivly logging the user out
*/
export function logOut() {
  return function (dispatch) {
    dispatch(loggingOut());
    dispatch(replace(redirect ? `/Login?redirect=${redirect}` : "/Login"));
    dispatch(refreshPage(true));
  };
}

/*
	Sends request for users assigned jobs
	string jwt - users token for authentication
*/
export function fetchJobs(jwt) {
  return function (dispatch) {
    dispatch(getJobs());
    let url = "api/getJobs";
    let options = {
      headers: {
        token: jwt,
      },
    };
    return fetch(url, options)
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) => dispatch(receiveJobs(json)))
      .catch((err) => console.log("fetchJobs", err));
  };
}

/*
	Sends authenticated request for a list of workorders
	string query - string of combined endpoint and GET params
*/
export function authFetchWorkorders(query, jwt) {
  let url = query;
  let options = {
    headers: {
      token: jwt,
    },
  };
  return function (dispatch) {
    dispatch(fetchWorkorders(url, options));
  };
}

/*
	Sends request for a list of workorders
	string query - string of combined endpoint and GET params
*/
export function fetchWorkorders(query, options) {
  return function (dispatch) {
    dispatch(getWorkorders());

    return fetch("api/" + query, options)
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) => dispatch(receiveWorkorders(json)))
      .catch((err) => console.log("fetchWorkorders", err));
  };
}

/*
	Sends authenticated request for a single workorders details
	string query - string of combined endpoint and GET params
*/
export function authFetchDetails(query, jwt) {
  let url = query;
  let options = {
    headers: {
      token: jwt,
    },
  };
  return function (dispatch) {
    dispatch(fetchDetails(url, options));
  };
}

/*
	Sends request for a single workorders details
	string location - job associated with workorder
	string query - GET params
*/
export function fetchDetails(query, options) {
  return function (dispatch) {
    dispatch(getDetails());

    return fetch("api/" + query, options)
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) => dispatch(receiveDetails(json)))
      .catch((err) => console.log("fetchDetails", err));
  };
}

/*
	Sends post request with collected form data
	string jwt - users token
	string location - job associated with workorder
	string jobId - id of job form is being submitted under
	object data - contains collected form data
*/
export function submitForm(jwt, location, jobId, data) {
  return function (dispatch) {
    var json = JSON.stringify({
      jwt,
      jobId,
      data,
    });
    return fetch("api/" + location + "/post/create", {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: json,
    })
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) =>
        dispatch(push("/job/" + location + "/View/" + location + "/" + json)),
      )
      .then(dispatch(snackbarAlert(location + "/post/create")))
      .catch((err) => console.log("submitForm", err));
  };
}

/*
	Sends post request with collected form data to update specific workorder
	string jwt - users token
	string location - job associated with workorder
	string formId - id of workorder to update
	string jobId - id of job form is being submitted under
	object data - contains collected form data
*/
export function updateForm(jwt, location, formId, jobId, data) {
  return function (dispatch) {
    var json = JSON.stringify({
      jwt,
      formId,
      jobId,
      data,
    });
    return fetch("api/" + location + "/put/update", {
      method: "put",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: json,
    })
      .then(handleErrors)
      .then((response) => response.json())
      .then((json) =>
        dispatch(fetchDetails(location, "?jwt=" + jwt + "&id=" + json)),
      )
      .then(dispatch(snackbarAlert(location + "/put/update")))
      .catch((err) => console.log("updateForm", err));
  };
}

/*
	Creates and clicks an HTML link to download a file
	string route - endpoint on backend to link to
	string jwt - users token
	string jobId - id of job associated with request
*/
export function downloadLink(route, jwt, jobId) {
  var link = document.createElement("a");
  link.setAttribute("href", `api/${route}&jwt=${jwt}&job=${jobId}`);
  link.setAttribute("download", "Download Link");
  clickLink(link);

  return {
    type: "DOWNLOAD_LINK",
    route,
  };
}

/*
	Creates and clicks an HTML link to download a pdf of a single workorder
	string wo - id of workorder
	string location - job associated with workorder
*/
export function downloadPdf(wo, location) {
  var link = document.createElement("a");
  link.setAttribute("href", +"api/" + location + "/download?id=" + wo._id);
  link.setAttribute("download", "P-Card Auth Form-" + wo.searchId);
  clickLink(link);

  return {
    type: "DOWNLOAD_PDF",
    wo,
    location,
  };
}

/*
	Creates and clicks a link to download a label from Stamps.com API
*/
export function downloadLabel(URL, options) {
  var link = document.createElement("a");
  link.setAttribute("href", URL);
  link.setAttribute("download", "StampsLabel.png");
  clickLink(link);

  return {
    type: "DOWNLOAD_LABEL",
    URL,
    options,
  };
}

/*
	Creates and clicks a mailTo link
	object wo - data from workorder
*/
export function emailUser(wo) {
  var link = document.createElement("a");
  link.setAttribute("href", `mailto:${wo.email}?Subject=${wo.title}`);
  clickLink(link);

  return {
    type: "EMAIL_USER",
    wo,
  };
}

/*
	Clicks the passed in link based on browser compatability
	DOMObject link - DOM link to click
*/
function clickLink(link) {
  if (document.createEvent) {
    var event = document.createEvent("MouseEvents");
    event.initEvent("click", true, true);
    link.dispatchEvent(event);
  } else {
    link.click();
  }
}

/*
	Generic callback for throwing fetch errors
	object response - object returned by fetch request
*/
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

/*
	Remaining functions are dispatched through Redux actions
	to be consumed by Reducers which update the Store
*/
export function setLoginMessage(message) {
  return {
    type: "LOGIN_MESSAGE",
    message,
  };
}
export function loggedIn(json) {
  return {
    type: "LOGGED_IN",
    data: json,
  };
}
export function receiveJobs(jobs) {
  return {
    type: "RECEIVE_JOBS",
    jobs,
  };
}
export function receiveWorkorders(workOrders) {
  return {
    type: "RECEIVE_WORKORDERS",
    workOrders,
    received: new Date(),
  };
}
export function receiveDetails(details) {
  return {
    type: "RECEIVE_DETAILS",
    details,
  };
}
export function openDialog(title, content, actions) {
  return {
    type: "OPEN_DIALOG",
    title: title,
    content: content,
    actions: actions,
    modal: false,
  };
}
export function refreshPage(forceGet) {
  location.reload(forceGet);
  return {
    type: "REFRESH_PAGE",
    forceGet: forceGet,
  };
}
export function closeDialog() {
  return {
    type: "CLOSE_DIALOG",
  };
}
export function snackbarAlert(endpoint) {
  return {
    type: "SNACKBAR_ALERT",
    endpoint,
  };
}
export function snackbarError(error) {
  return {
    type: "SNACKBAR_ERROR",
    error,
  };
}
export function snackbarClose() {
  return {
    type: "SNACKBAR_CLOSE",
  };
}
export function changeTab(value) {
  return {
    type: "CHANGE_TAB",
    value,
  };
}
export function loggingIn() {
  return {
    type: "LOGGING_IN",
  };
}
export function loggingOut() {
  return {
    type: "LOGGING_OUT",
  };
}
export function getJobs() {
  return {
    type: "GET_JOBS",
  };
}
export function getWorkorders() {
  return {
    type: "GET_WORKORDERS",
  };
}
export function getDetails(id) {
  return {
    type: "GET_DETAILS",
  };
}
export function toggleNav() {
  return {
    type: "TOGGLE_NAV",
  };
}
export function stopLoading() {
  return {
    type: "STOP_LOADING",
  };
}



// WEBPACK FOOTER //
// ./app/actions/actionCreators.js